import { Dispatch, SetStateAction, useCallback, useState } from 'react';

import { useModalState } from '@/hooks/useModalState';

interface UseSummaryModalResult {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  transitionOnNewSummary: boolean;
  setTransitionOnNewSummary: Dispatch<SetStateAction<boolean>>;
}

/**
 * Manages the regenerate summary modal state and transition behavior.
 * Controls modal open/close state and tracks whether the UI should automatically
 * transition to display the new summary when it becomes available.
 */
export function useSummaryModal(): UseSummaryModalResult {
  const [modalState, { openModal, closeModal }] = useModalState();
  const [transitionOnNewSummary, setTransitionOnNewSummary] = useState(false);

  const open = useCallback(() => {
    openModal();
  }, [openModal]);

  return {
    isOpen: modalState.isModalOpen,
    open,
    close: closeModal,
    transitionOnNewSummary,
    setTransitionOnNewSummary,
  };
}
